<div class="p-5">
    <h2 class="mb-4">Full Calendar</h2>
    <div class="card">
      <div class="card-body p-0">
        <div id="calendar"></div>
      </div>
    </div>
  </div>
  
  <!-- calendar modal -->
  <div id="modal-view-event" class="modal modal-top fade calendar-modal">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-body">
                      <h4 class="modal-title"><span class="event-icon"></span><span class="event-title"></span></h4>
                      <div class="event-body"></div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
              </div>
          </div>
      </div>
  
  <div id="modal-view-event-add" class="modal modal-top fade calendar-modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <form id="add-event">
          <div class="modal-body">
          <h4>Add Event Detail</h4>        
            <div class="form-group">
              <label>Event name</label>
              <input type="text" class="form-control" name="ename">
            </div>
            <div class="form-group">
              <label>Event Date</label>
              <input type='text' class="datetimepicker form-control" name="edate">
            </div>        
            <div class="form-group">
              <label>Event Description</label>
              <textarea class="form-control" name="edesc"></textarea>
            </div>
            <div class="form-group">
              <label>Event Color</label>
              <select class="form-control" name="ecolor">
                <option value="fc-bg-default">fc-bg-default</option>
                <option value="fc-bg-blue">fc-bg-blue</option>
                <option value="fc-bg-lightgreen">fc-bg-lightgreen</option>
                <option value="fc-bg-pinkred">fc-bg-pinkred</option>
                <option value="fc-bg-deepskyblue">fc-bg-deepskyblue</option>
              </select>
            </div>
            <div class="form-group">
              <label>Event Icon</label>
              <select class="form-control" name="eicon">
                <option value="circle">circle</option>
                <option value="cog">cog</option>
                <option value="group">group</option>
                <option value="suitcase">suitcase</option>
                <option value="calendar">calendar</option>
              </select>
            </div>        
        </div>
          <div class="modal-footer">
          <button type="submit" class="btn btn-primary" >Save</button>
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>        
        </div>
        </form>
      </div>
    </div>
  </div>
  
  
  <div class="related-product">
              <div class="container">
          <h1 class="text-center mb-5">Bootstrap 4 Admin Panel</h1>
                  <ul class="row justify-content-center">
                      <li class="col-md-6 col-sm-12">
                          <a href="https://github.com/dropways/deskapp">
                              <div class="related-box">
                                  <img src="https://dropways.github.io/feathericons/assets/themes/twitter/images/deskapp.png" alt="deskapp">
                              </div>
                              <h3>DeskApp Bootstrap 4 admin template</h3>
                              <p>DeskApp Admin is a free to use Bootstrap 4 admin template. This template uses the default Bootstrap 4 styles along with a variety of powerful jQuery plugins and tools to create a powerful framework for creating admin panels or back-end dashboards.</p>
                          </a>
              <div class="text-center">
                <a href="https://github.com/dropways/deskapp" target="_blank" class="btn btn-primary btn-lg download-btn"><i class="fa fa-github"></i> Download Now</a>
              </div>
                      </li>
                  </ul>
              </div>
          </div>